import { IDeleteChecklistMaquinaEquipItensUseCase } from "../../../presentation/useCases/delete/delete_checklist_maquina_equip_itenss_use_case";
import { IControlePatrimonioRepository } from "../../repositories/ControledePatrimonio";

/**
 * DeleteChecklistMaquinaEquipItenssUseCase
 */

export class DeleteChecklistMaquinaEquipItensUseCase implements IDeleteChecklistMaquinaEquipItensUseCase {
  constructor(private readonly repository: IControlePatrimonioRepository) { }

  async execute(
    idChecklistMaquinaEquipItem: number[]
  ): Promise<void> {
    for (const id of idChecklistMaquinaEquipItem) {
      await this.repository.deleteChecklistMaquinaEquipItem(id);
    }
    // await this.repository.deleteChecklistMaquinaEquipItem(idChecklistMaquinaEquipItem);
  }
}
